import 'core-js';

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueLazyLoad from 'vue-lazyload';
import VueMq from 'vue-mq';

import { loading } from 'scripts/config/images.js';
import components from './components/index.js';
import store from './store/index.js';
import { ucfirst, upcase, unhandleize } from './filters/string.js';
import { money, moneyWithoutDecimals } from './filters/money.js';
import render from './helpers/module.js';

__webpack_public_path__ = window.__webpack_public_path__; // eslint-disable-line no-underscore-dangle, camelcase

const cssVars = require('../styles/variables.scss');

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);

Vue.use(VueLazyLoad, {
  loading,
  preload: 1.3,
  attempt: 1,
});

Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(cssVars.breakTablet, 10),
    tablet: parseInt(cssVars.breakDesktop, 10),
    desktop: parseInt(cssVars.breakHd, 10),
    hd: Infinity,
  },
});

Vue.filter('ucfirst', ucfirst);
Vue.filter('upcase', upcase);
Vue.filter('unhandleize', unhandleize);
Vue.filter('money', money);
Vue.filter('moneyWithoutDecimals', moneyWithoutDecimals);

window.addEventListener('DOMContentLoaded', () => {
  const vueRoots = document.querySelectorAll('[data-vue-root]');

  vueRoots.forEach((root) => {
    render({
      root,
      component: new Vue({ store }),
      is: components[root.dataset.vueRoot],
    });
  });
});